import React from "react";
import { assets } from "../../../../assets/assets";
import { useNavigate } from "react-router-dom";

const DoctorNotFound: React.FC = () => {
    const navigate = useNavigate();

    const handleBack = () => {
        navigate(-1);
    };

    const handleHome = () => {
        navigate("/");
    }
    
    const handleLogoError = (event: React.SyntheticEvent<HTMLImageElement, Event>) => {
        event.currentTarget.style.display = "none";
    };

    return (
        <div className="flex flex-col items-center justify-center min-h-screen bg-gray-100 px-4 py-12">
            {" "}
            <div className="max-w-md w-full bg-white rounded-lg shadow-md overflow-hidden">
                <div className="bg-gray-100 flex justify-center py-8">
                    {" "}
                    <div className="rounded-full bg-gray-200 p-4">
                        {" "}
                        <img src={assets?.notfound_icon} alt="Doctor not found illustration" />
                    </div>
                </div>

                {/* Content */}
                <div className="px-6 py-8">
                    <h1 className="text-2xl font-bold text-center text-gray-900 mb-4"> Doctor Not Found</h1>

                    <p className="text-gray-700 text-center mb-6">
                        We couldn't find the doctor you're looking for. The profile may have been removed or the URL
                        might be incorrect.
                    </p>

                    <div className="space-y-4">
                        <div className="bg-gray-100 rounded-md p-4">
                            {" "}
                            <div className="flex">
                                <div className="flex-shrink-0">
                                    <svg
                                        className="h-5 w-5 text-gray-500"
                                        xmlns="http://www.w3.org/2000/svg"
                                        viewBox="0 0 20 20"
                                        fill="currentColor"
                                    >
                                        <path
                                            fillRule="evenodd"
                                            d="M18 10a8 8 0 11-16 0 8 8 0 0116 0zm-7-4a1 1 0 11-2 0 1 1 0 012 0zM9 9a1 1 0 000 2v3a1 1 0 001 1h1a1 1 0 100-2v-3a1 1 0 00-1-1H9z"
                                            clipRule="evenodd"
                                        />
                                    </svg>
                                </div>
                                <div className="ml-3">
                                    <h3 className="text-sm font-medium text-gray-800"> What you can do</h3>
                                    <div className="mt-2 text-sm text-gray-700">
                                        {" "}
                                        <ul className="list-disc pl-5 space-y-1">
                                            <li>Check the URL for any errors</li>
                                            <li>Return to the clinic's homepage</li>
                                            <li>Contact support for assistance</li>
                                        </ul>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div className="flex flex-col sm:flex-row gap-3 mt-8">
                        <div
                            onClick={handleBack}
                            className="flex-1 inline-flex justify-center items-center px-4 py-2 border border-transparent text-sm font-medium rounded-md shadow-sm text-white bg-gray-800 hover:bg-gray-900 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-gray-500"
                        >
                            Go Back
                        </div>
                        <a
                            onClick={handleHome}
                            className="flex-1 inline-flex justify-center items-center px-4 py-2 border border-gray-300 text-sm font-medium rounded-md shadow-sm text-gray-700 bg-white hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-gray-500"
                        >
                            Find Doctors
                        </a>
                    </div>
                </div>

                {/* Footer */}
                <div className="px-6 py-4 bg-gray-100 flex items-center justify-center space-x-2 text-gray-500 text-xs border-t border-gray-200">
                    {" "}
                    <span>Powered by</span>
                    <img src={assets.logo} alt="Platform Logo" className="h-4 w-auto" onError={handleLogoError} />
                </div>
            </div>
        </div>
    );
};

export default DoctorNotFound;
